// extracted by mini-css-extract-plugin
export default {"filled":"info-circle_filled__Y2KUG","outlined":"info-circle_outlined__EWqkt"};